import {FieldConfiguration} from '../../file/message/FieldConfiguration';
import {FileConfiguration} from '../../file/message/FileConfiguration';
import {PredefinedBaseConfiguration} from './PredefinedBaseConfiguration';

export class FileTableConfiguration extends PredefinedBaseConfiguration {
chunkSize: number | null;
fields: FieldConfiguration[];
file: FileConfiguration;
tableName: string;
}

